import colors from '../../../theming/docusign-themes/olive/colors'
import type { Tokens } from '../../../theming/types'
import type { ToastMessageProps } from '..'

const borderColor = {
  danger: colors.persianRed_alpha27,
  information: colors.funBlue_alpha27,
  success: colors.mantisGreen_alpha27,
  warning: colors.sunglowYellowDark_alpha43,
} as const

export default (config: {
  props: Pick<ToastMessageProps, 'kind'>
  tokens: Tokens
}) => {
  const { props, tokens } = config
  const { kind = 'information' } = props

  const kindStyles = {
    danger: {
      wrap: {
        background: colors.persianRedPale2,
        border: `1px solid ${borderColor.danger}`,
        borderInlineStart: `4px solid ${colors.persianRed}`,
        color: colors.persianRedDark,
      },
      icon: {
        color: tokens.iconColorError,
      },
    },
    information: {
      wrap: {
        background: colors.funBluePale2,
        border: `1px solid ${borderColor.information}`,
        borderInlineStart: `4px solid ${colors.funBlue}`,
        color: colors.black,
      },
      icon: {
        color: colors.funBlue,
      },
    },
    success: {
      wrap: {
        background: colors.mantisGreenPale2,
        border: `1px solid ${borderColor.success}`,
        borderInlineStart: `4px solid ${colors.mantisGreen}`,
        color: colors.black,
      },
      icon: {
        color: tokens.iconColorSuccess,
      },
    },
    warning: {
      wrap: {
        background: colors.sunglowYellowPale2,
        border: `1px solid ${borderColor.warning}`,
        borderInlineStart: `4px solid ${colors.sunglowYellowDark3}`,
        color: colors.black,
      },
      icon: {
        color: colors.sunglowYellowDark3,
      },
    },

    loading: {
      wrap: {
        background: colors.funBluePale2,
        border: `1px solid ${borderColor.information}`,
        borderInlineStart: `4px solid ${colors.funBlue}`,
        color: colors.black,
      },
      icon: undefined,
    },
  }

  return {
    default: {
      wrap: {
        ...tokens.fontBodyM,
        ...kindStyles[kind].wrap,
        alignItems: 'flex-start',
        borderRadius: '2px',
        boxShadow: tokens.elevationMedium,
        display: 'flex',
        justifyContent: 'center',
        overflow: 'hidden',
        padding: '16px',
        width: '100%',
      },

      action: {
        marginBlock: '4px 0',
        marginInline: '-12px 0',
      },

      icon: {
        ...kindStyles[kind].icon,
        height: '16px',
      },

      body: {
        alignSelf: 'center',
      },

      startElement: {
        marginInlineEnd: '14px',
      },

      closeButton: {
        marginBlock: '-6px',
        marginInline: '8px -6px',
      },
    },
  }
}
